import { Close, Delete, Edit, Filter, Refresh } from 'assets/Icons';
import { Scrollbar } from 'components';
const Icons = () => {
   const icons = [
      { component: <Close />, width: '22', height: '22' },
      { component: <Delete />, width: '24', height: '24' },
      { component: <Edit />, width: '24', height: '24' },
      { component: <Filter />, width: '20', height: '20' },
      { component: <Refresh />, width: '24', height: '24' },
   ];
   return (
      <div className='h-[100vh] w-full p-[20px]'>
         <h1 className='font-semibold text-[24px]'>Icons</h1>
         <div className='pt-[20px] h-[calc(100%-36px)]'>
            <div className='h-full'>
               <Scrollbar>
                  <div className='flex w-full flex-wrap'>
                     {icons.map(icon => {
                        return (
                           <div className='w-[36px] h-[36px] flex items-center justify-center'>
                              {icon?.component}
                           </div>
                        );
                     })}
                  </div>
               </Scrollbar>
            </div>
         </div>
      </div>
   );
};
export default Icons;
